import { Editor, useEditorState } from '@tiptap/react'
import { Select } from 'antd'

import { useTranslation } from 'react-i18next'

import { useStyles } from './styles'

type Props = {
  editor: Editor
}

const fontSizeOptions = [
  { label: '12px', value: '12px' },
  { label: '14px', value: '14px' },
  { label: '16px', value: '16px' },
  { label: '18px', value: '18px' },
  { label: '20px', value: '20px' },
  { label: '24px', value: '24px' },
  { label: '28px', value: '28px' },
  { label: '32px', value: '32px' }
]

export const FontSizeSelect = ({ editor }: Props) => {
  const { t } = useTranslation()
  const { styles } = useStyles()

  const editorState = useEditorState({
    editor,
    selector: (ctx) => {
      const { state } = ctx.editor
      const { selection } = state
      const marks = state.storedMarks || selection.$from.marks()

      const textStyleMark = marks.find((mark) => mark.type.name === 'textStyle')
      const currentFontSize = (textStyleMark?.attrs?.fontSize as string) || null

      return {
        fontSize: currentFontSize
      }
    }
  })

  const onFontSizeChange = (value: string | null) => {
    if (!value) {
      editor.chain().focus().unsetFontSize().run()
    } else {
      editor.chain().focus().setFontSize(value).run()
    }
  }

  return (
    <Select
      value={editorState.fontSize}
      options={fontSizeOptions}
      onChange={onFontSizeChange}
      placeholder={t('editor.font_size')}
      allowClear
      className={styles.fontFamilySelect}
    />
  )
}
